import type { GossipItem } from '@/mocks/gossip';
import { socialNews } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

function SocialRow({ item }: { item: GossipItem }) {
  return (
    <article id={item.id} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-background-300 sm:flex-row">
      <div className="relative aspect-[16/9] w-full overflow-hidden sm:aspect-auto sm:w-[44%]">
        <img
          src={item.img}
          alt={item.alt}
          title={`${item.title} - 吃瓜视界`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">{item.tag}</span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 text-accent-700">
            <i className="ri-megaphone-line" style={{ width: 14, height: 14 }} />
            {item.section}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-time-line" style={{ width: 14, height: 14 }} />
            {item.time}
          </span>
        </div>
        <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-accent-700 md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line" style={{ width: 14, height: 14 }} />
            {item.views}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-chat-1-line" style={{ width: 14, height: 14 }} />
            {item.comments}
          </span>
        </div>
      </div>
    </article>
  );
}

export default function NewsRows() {
  return (
    <section id="social" className="bg-background-50 py-14 md:py-20" aria-labelledby="social-title">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Society & Trends"
          title="社会热点 · 生活趋势"
          desc="从演唱会经济到博物馆夜游，从票房回暖到国潮市集，热点背后是正在发生的生活，我们用资讯帮你看清它们为何而火。"
        />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {socialNews.map((item) => (
            <SocialRow key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}